var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrustedIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96.943,
    height: 105.541,
    viewBox: "0 0 96.943 105.541",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .prefix__cls-1{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-width:6px}\r\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_13",
    "data-name": "Group 13",
    transform: "translate(4.156 3.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_13",
    d: "M42.008 55.79s-3.133 29.271 33.453 26.138",
    className: "prefix__cls-1",
    "data-name": "Path 13",
    transform: "translate(2.429 4.353)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_14",
    d: "M63.507 98.714s-15.678-4.182-23-15.678a40.817 40.817 0 01-5.754-13.263 21.662 21.662 0 01.235-11.473c2.757-8.033 14.482-10.6 20.794-5.184 3.669 3.145 3.737 8.261 5.2 12.511 2.085 6.1 8.671 9.788 15.04 8.9a13.572 13.572 0 0010.232-8.34c1.55-4.375.729-9.389-.547-13.73a37.588 37.588 0 00-9.457-15.633 38.738 38.738 0 00-6.962-5.594c-11.068-6.942-25.709-7.43-37.741-2.977A36.975 36.975 0 0014.98 40.034C8.3 48.523 6.411 61.353 8.542 71.733a80.309 80.309 0 003.726 12.351",
    className: "prefix__cls-1",
    "data-name": "Path 14",
    transform: "translate(-2.344 .112)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_15",
    d: "M72.9 63.26c-.6-10.824-6.817-21.694-17.254-25.66-11.064-4.2-24.349-.057-31.288 9.434-7.395 10.107-6.347 23.985-.479 34.535A59.536 59.536 0 0036.3 96.713",
    className: "prefix__cls-1",
    "data-name": "Path 15",
    transform: "translate(-.75 1.589)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_16",
    d: "M3 38.086s16.43-24.908 44.961-24.053c34.5 1.048 43.913 24.053 43.913 24.053",
    className: "prefix__cls-1",
    "data-name": "Path 16",
    transform: "translate(-3 -1.471)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_17",
    d: "M15.27 12.012C22.836 6.52 33.3 2.635 46.251 3.033c14.539.444 24.623 3.737 31.425 8.6",
    className: "prefix__cls-1",
    "data-name": "Path 17",
    transform: "translate(-1.289 -3.005)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrustedIcon);
export default __webpack_public_path__ + "static/media/trusted-icon.683be07964c5d82b662641b71655af68.svg";
export { ForwardRef as ReactComponent };